import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Checkbox, Tooltip, Typography, WithInfoIcon, ConditionalWrapper } from 'seagull';
import { useLocaleKeys } from '~/i18n';
export function AllowManualPaymentsCheckbox(props) {
    const { value, isSampleRelationship = false, isReadOnly, onChange, dataAgentTarget } = props;
    const { t: controllerTexts } = useLocaleKeys('components.agreementControllers');
    return /*#__PURE__*/ _jsx(WithInfoIcon, {
        info: controllerTexts.allowManualPaymentsInfo(),
        "data-agent-target": dataAgentTarget,
        children: /*#__PURE__*/ _jsx(ConditionalWrapper, {
            condition: isSampleRelationship,
            wrapper: (children)=>/*#__PURE__*/ _jsx(Tooltip, {
                    placement: "top",
                    title: /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                skin: "invertedStandard",
                                weight: "bold",
                                children: controllerTexts.testingModeDisablesPayments()
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                skin: "invertedStandard",
                                children: controllerTexts.testingModeDisablesPaymentsInfo()
                            })
                        ]
                    }),
                    children: /*#__PURE__*/ _jsx("div", {
                        children: children
                    })
                }),
            children: /*#__PURE__*/ _jsx(Checkbox, {
                testId: "agreement-studio-allow-manual-payments-Checkbox",
                bi: {
                    name: 'allow_manual_payments'
                },
                checked: value && !isSampleRelationship,
                disabled: isSampleRelationship || isReadOnly,
                onChange: ()=>onChange(!value),
                children: /*#__PURE__*/ _jsx(Typography, {
                    skin: isSampleRelationship ? 'disabled' : 'standard',
                    children: controllerTexts.letClientManuallyApprovePayments()
                })
            })
        })
    });
}
